// api/axiosConfig.js
import axios from 'axios';

// Use the production API URL
//const API_BASE_URL = 'http://192.168.100.101:8000/api/';

const API_BASE_URL = 'https://webcms-app.sj.co.tz/api/';


const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'ApiAuth': 'NA'
  },
});

// Add a request interceptor to include the token and site ID
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    const siteId = localStorage.getItem('siteId');

    console.log("Interceptor - Token from localStorage:", token);
    console.log("Interceptor - Site ID from localStorage:", siteId);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (siteId) {
      config.headers['SID'] = siteId;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for better error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('siteId');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;